import axios, { CancelToken } from "axios";
import { CollectionIndexModel } from "@/api/CollectionEvents";
import { executeApiRequestWithCancellation } from "@/plumbing/http/apiClient";

export type ListCollectionIndexesRequest = {
  eventDate: Date;
  boundary?: number[];
  resolution?: number;
};

export type ListCollectionIndexesResponse =
  | {
      indexes: CollectionIndexModel[];
    }
  | undefined;

export const listCollectionIndexes = async (request: ListCollectionIndexesRequest, cancellationToken: CancelToken) => {
  const response = await executeApiRequestWithCancellation(
    () =>
      //TODO: Need to change this to a GET request http://jira.jjrichards.com.au/browse/DCPR-432
      axios.post<ListCollectionIndexesResponse>(
        "/collectionevents/generate-indexes",
        {
          eventDate: request.eventDate,
          boundary: request.boundary,
          resolution: request.resolution
        },
        {
          cancelToken: cancellationToken
        }
      ),
    false
  );
  return response?.data;
};
